/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  NotificationPreference,
  NotificationPreferenceUpdateInput,
  NotificationPreferencesList,
  SchemaValidationErrorResponse,
  StandardError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary List notification preferences
 */
export const notificationPreferences = (

 signal?: AbortSignal
) => {


      return axiosClient<NotificationPreferencesList>(
      {url: `/notification-preferences`, method: 'GET', signal
    },
      );
    }




export const getNotificationPreferencesQueryKey = () => {
    return [
    'notification-preferences'
    ] as const;
    }


export const getNotificationPreferencesQueryOptions = <TData = Awaited<ReturnType<typeof notificationPreferences>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationPreferences>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getNotificationPreferencesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationPreferences>>> = ({ signal }) => notificationPreferences(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof notificationPreferences>>, TError, TData>
}

export type NotificationPreferencesQueryResult = NonNullable<Awaited<ReturnType<typeof notificationPreferences>>>
export type NotificationPreferencesQueryError = ErrorType<StandardError>


/**
 * @summary List notification preferences
 */

export function useNotificationPreferences<TData = Awaited<ReturnType<typeof notificationPreferences>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationPreferences>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getNotificationPreferencesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update a notification preference
 */
export const updateNotificationPreference = (
    id: MaybeRefOrGetter<string>,
    notificationPreferenceUpdateInput?: MaybeRefOrGetter<NotificationPreferenceUpdateInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
notificationPreferenceUpdateInput = toValue(notificationPreferenceUpdateInput);

      return axiosClient<NotificationPreference>(
      {url: `/notification-preferences/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: notificationPreferenceUpdateInput, signal
    },
      );
    }




export const getUpdateNotificationPreferenceMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateNotificationPreference>>, TError,UpdateNotificationPreferenceMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateNotificationPreference>>, TError,UpdateNotificationPreferenceMutationVariables, TContext> => {

const mutationKey = ['updateNotificationPreference'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateNotificationPreference>>, UpdateNotificationPreferenceMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  updateNotificationPreference(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateNotificationPreferenceMutationResult = NonNullable<Awaited<ReturnType<typeof updateNotificationPreference>>>
    export type UpdateNotificationPreferenceMutationBody = NotificationPreferenceUpdateInput | undefined
    export type UpdateNotificationPreferenceMutationError = ErrorType<SchemaValidationErrorResponse | StandardError | void>
    export type UpdateNotificationPreferenceMutationVariables = {id: string;data?: NotificationPreferenceUpdateInput}

    /**
 * @summary Update a notification preference
 */
export const useUpdateNotificationPreference = <TError = ErrorType<SchemaValidationErrorResponse | StandardError | void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateNotificationPreference>>, TError,UpdateNotificationPreferenceMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateNotificationPreference>>,
        TError,
        UpdateNotificationPreferenceMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateNotificationPreferenceMutationOptions(options), queryClient);
    }
